import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IEmployeeObservations } from '@app/activo2/manage-vacations/manage-vacations.interface';
import { MomoVacationsProposal, MomoSeasonProposal } from '@app/activo2/manage-vacations/manage-vacations.model';

@Component({
  selector: 'app-momo-first-step',
  templateUrl: './first-step.component.html',
  styleUrls: ['./first-step.component.scss']
})
export class FirstStepComponent implements OnInit {
  @Input() proposals!: MomoVacationsProposal;
  @Input() canEdit!: boolean;
  @Output() actionClicked: EventEmitter<MomoSeasonProposal> = new EventEmitter<MomoSeasonProposal>();
  @Output() addProposalsClicked: EventEmitter<MomoSeasonProposal> = new EventEmitter<MomoSeasonProposal>();
  @Output() observationsChanged: EventEmitter<IEmployeeObservations> = new EventEmitter<IEmployeeObservations>();

  mappedObservations!: IEmployeeObservations;

  get hasData() {
    return this.proposals && this.proposals.userHasData();
  }

  ngOnInit() {
    this.mappedObservations = { id: undefined, content: this.proposals.observations };
  }

  onActionClicked(proposal: MomoSeasonProposal, order: number) {
    proposal.setProposalOrder(order);
    this.actionClicked.emit(proposal);
  }

  onAddProposalsClicked(proposal: MomoSeasonProposal) {
    this.addProposalsClicked.emit(proposal);
  }

  onObservationsChanged(observations: IEmployeeObservations) {
    this.observationsChanged.emit(observations);
  }
}
